/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

/**
 * Get Address value
 * @param address
 * @returns {*}
 */
const getAddressValue = (address) => {
    const retAddress = address.value || address;
    return retAddress;
};

export default class AddressStandardizationService {

    static findStandardizedAddresses(anAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayaddressstandardization'),
            'findStandardizedAddresses',
            [getAddressValue(anAddress)],
            additionalHeaders
        );
    }

    static pickStandardizedAddress(pickedAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayaddressstandardization'),
            'pickStandardizedAddress',
            [getAddressValue(pickedAddress)],
            additionalHeaders
        );
    }

    static pickOverrideAddress(overrideAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayaddressstandardization'),
            'pickOverrideAddress',
            [getAddressValue(overrideAddress)],
            additionalHeaders
        );
    }

    static getPCPortalConstants(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaconstants'),
            'getPCPortalConstants',
            [],
            additionalHeaders
        );
    };
}